// extracted by mini-css-extract-plugin
export default {"review-action-modal-content-wrap":"actionModal_review-action-modal-content-wrap__YR36s","menu-button":"actionModal_menu-button__1NPt9"};